import { PasswordInput } from 'components/Inputs/PasswordInput';
import { FC } from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { PasswordStrength } from 'components/PasswordStrength';

type Props = {
  firstPassword?: boolean;
};

export const RecoveryPasswordForm: FC<Props> = ({
  children,
  firstPassword,
}) => {
  return (
    <Box
      sx={{ height: '100%' }}
      alignContent="center"
      alignItems="center"
      justifyContent="space-evenly"
      display="flex"
      flexDirection="column"
      flex={1}
      py={4}
    >
      <Grid
        container
        spacing={2}
        sx={{ px: { xl: 6, lg: 4, md: 2, sm: 2, xs: 2 } }}
      >
        <Grid item container xs={12} justifyContent="center">
          <Grid item xs={12}>
            <Typography
              component="h1"
              variant="h5"
              sx={{ fontWeight: 400, fontSize: 24 }}
              textAlign="center"
            >
              {firstPassword ? 'Definir senha' : 'Redefinir senha'}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography mt={3} mb={4} textAlign="center">
              {firstPassword
                ? 'Crie uma senha para continuar'
                : 'Crie uma nova senha para continuar'}
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <PasswordInput
            required
            fullWidth
            id="password"
            name="password"
            label={firstPassword ? 'Crie sua senha' : 'Crie sua nova senha'}
          />
        </Grid>

        <Grid item xs={12}>
          <PasswordInput
            required
            fullWidth
            id="password-confirmation"
            name="passwordConfirmation"
            label={
              firstPassword ? 'Confirme sua senha' : 'Confirme sua nova senha'
            }
          />
        </Grid>

        <Grid item xs={12}>
          {children}
        </Grid>

        <PasswordStrength />
      </Grid>
    </Box>
  );
};
